import { RentalState } from '@profile/src/utils/types';
import dayjs from 'dayjs';
export const formatType = status => {
  switch (status) {
    case RentalState.OWNER_FOR_RENT:
      return 'Listing';

    case RentalState.OWNER_STOP_FOR_RENT:
      return 'De-Listing';

    case RentalState.OWNER_RENTED:
      return 'Rented Out';

    case RentalState.RENTER_RENTED:
      return 'Rented';

    case RentalState.OWNER_RETURN:
    case RentalState.RENTER_RETURN:
      return 'Return';

    default:
      return '';
  }
};
export const rentedTimeSince = timestamp => {
  return dayjs.unix(timestamp).fromNow();
};